/**
 * @owner @Appboy/messaging-experience
 */

import { canvasRemoteLookupValidators } from "@schemas/remoteLookup/canvasRemoteLookupSchema";
import type { CanvasRemoteLookupId, CanvasRemoteLookupItem, CanvasRemoteLookupFilters } from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const canvasProvider: RemoteLookupProvider<
  CanvasRemoteLookupId,
  CanvasRemoteLookupItem,
  CanvasRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  // The backend searches Canvases on name; match on name only (display fallbacks
  // for unnamed Canvases belong in the consuming RemoteSelect's mapItemToOption).
  mapItemToSearchString: (item) => item.name ?? "",
  validators: {
    ...canvasRemoteLookupValidators,
    // non-strict typescript issue
    item: canvasRemoteLookupValidators.item as z.ZodType<CanvasRemoteLookupItem>,
  },
};
